import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Svenska",
  code: "sv",
  messages: {
    alert: {
      close: "St\xE4ng"
    },
    authForm: {
      hidePassword: "D\xF6lj l\xF6senord",
      showPassword: "Visa l\xF6senord",
      submit: "Forts\xE4tt"
    },
    banner: {
      close: "St\xE4ng"
    },
    calendar: {
      nextMonth: "N\xE4sta m\xE5nad",
      nextYear: "N\xE4sta \xE5r",
      prevMonth: "F\xF6reg\xE5ende m\xE5nad",
      prevYear: "F\xF6reg\xE5ende \xE5r"
    },
    carousel: {
      dots: "V\xE4lj bild att visa",
      goto: "G\xE5 till {slide}",
      next: "N\xE4sta",
      prev: "F\xF6reg\xE5ende"
    },
    chatPrompt: {
      placeholder: "Skriv ditt meddelande h\xE4r..."
    },
    chatPromptSubmit: {
      label: "Skicka"
    },
    colorMode: {
      dark: "M\xF6rkt",
      light: "Ljust",
      switchToDark: "Byt till m\xF6rkt l\xE4ge",
      switchToLight: "Byt till ljust l\xE4ge",
      system: "System"
    },
    commandPalette: {
      back: "Tillbaka",
      close: "St\xE4ng",
      noData: "Inga data",
      noMatch: "Inga matchande data",
      placeholder: "Skriv ett kommando eller s\xF6k..."
    },
    contentSearch: {
      links: "L\xE4nkar",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "S\xF6k..."
    },
    contentToc: {
      title: "P\xE5 denna sida"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "S\xF6k..."
    },
    dashboardSidebarCollapse: {
      collapse: "Minimera sidof\xE4ltet",
      expand: "Expandera sidof\xE4ltet"
    },
    dashboardSidebarToggle: {
      close: "St\xE4ng sidof\xE4ltet",
      open: "\xD6ppna sidof\xE4ltet"
    },
    error: {
      clear: "Tillbaka till startsidan"
    },
    fileUpload: {
      removeFile: "Ta bort {filename}"
    },
    header: {
      close: "St\xE4ng menyn",
      open: "\xD6ppna menyn"
    },
    inputMenu: {
      create: 'Skapa "{label}"',
      noData: "Inga data",
      noMatch: "Inga matchande data"
    },
    inputNumber: {
      decrement: "Minska",
      increment: "\xD6ka"
    },
    modal: {
      close: "St\xE4ng"
    },
    pricingTable: {
      caption: "Prisplanering"
    },
    prose: {
      codeCollapse: {
        closeText: "Minimera",
        name: "kod",
        openText: "Expandera"
      },
      collapsible: {
        closeText: "D\xF6lj",
        name: "egenskaper",
        openText: "Visa"
      },
      pre: {
        copy: "Kopiera kod till urklipp"
      }
    },
    selectMenu: {
      create: 'Skapa "{label}"',
      noData: "Inga data",
      noMatch: "Inga matchande data",
      search: "S\xF6k..."
    },
    slideover: {
      close: "St\xE4ng"
    },
    table: {
      noData: "Inga data"
    },
    toast: {
      close: "St\xE4ng"
    }
  }
});
